module.exports = __webpack_public_path__ + "img/card4.d98cdf4f.jpg";